import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Reveal } from "@/components/Reveal";

const LegalLayout = ({ title, updated, children, testId }) => (
  <div className="min-h-screen bg-navy">
    <Header />
    <main className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-8" data-testid={testId}>
      <Reveal>
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-white">{title}</h1>
        <p className="mt-3 text-sm text-cream/40">Senast uppdaterad: {updated}</p>
      </Reveal>
      <div className="mt-10 space-y-9">{children}</div>
    </main>
    <Footer />
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-cream/70">{children}</div>
  </section>
);

export default LegalLayout;
